export function ArticleGridSkeleton({ count = 6 }: { count?: number }) {
  return (
    <section className="container-editorial py-10" aria-label="Loading stories" aria-busy="true">
      <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} className="flex flex-col gap-3">
            <div className="aspect-[16/10] w-full animate-pulse bg-muted" />
            <div className="h-4 w-24 animate-pulse bg-muted" />
            <div className="h-6 w-full animate-pulse bg-muted" />
            <div className="h-6 w-4/5 animate-pulse bg-muted" />
          </div>
        ))}
      </div>
    </section>
  );
}
